import React from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
} from "reactstrap";
import BackButtonSvg from "../../common/BackButtonSvg";
export default function LicenseDetails() {
  return (
    <div>      
      <div className="wrapper">
        <Container fluid>
          <div className="page-title">
            <h4>License Details</h4>

            <div className="top-btn">
              <Button color="primary">
                 <BackButtonSvg />
                Back</Button>
            </div>
          </div>

<Row>
    <Col md="3" className="h-100">
    <Card body className="mt-4">
       <div className="vertical-tab">
<span>Plan</span>
<Button color="primary" block>Plan Details</Button>


<span className="mt-5">License Category</span>
<Button color="secondary" block>Plan Details</Button>
<Button color="secondary" block>Plan Details</Button>




       </div>



       </Card>
    </Col>
    <Col md="9">
    <Card body className="mt-4">

<h4 className="text-center mb-5">Plan Details</h4>

<Row className="plan-list">
    <Col md="4">
        <div className="box">
<h4>Base</h4>
<h1><strong>$</strong>102<span>/12 month</span></h1>
<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500sLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</p>
    
    <ul>
        <li>
            <svg xmlns="http://www.w3.org/2000/svg" width="17.011" height="17.011" viewBox="0 0 17.011 17.011">
  <path id="Icon_material-check-box" data-name="Icon material-check-box" d="M19.621,4.5H6.39A1.89,1.89,0,0,0,4.5,6.39V19.621a1.89,1.89,0,0,0,1.89,1.89H19.621a1.89,1.89,0,0,0,1.89-1.89V6.39A1.89,1.89,0,0,0,19.621,4.5ZM11.115,17.731,6.39,13.005l1.333-1.333,3.393,3.383,7.173-7.173,1.333,1.342Z" transform="translate(-4.5 -4.5)" fill="#fff"/>
</svg>
 Park License</li>
        <li>
            <svg xmlns="http://www.w3.org/2000/svg" width="17.011" height="17.011" viewBox="0 0 17.011 17.011">
  <path id="Icon_material-check-box" data-name="Icon material-check-box" d="M19.621,4.5H6.39A1.89,1.89,0,0,0,4.5,6.39V19.621a1.89,1.89,0,0,0,1.89,1.89H19.621a1.89,1.89,0,0,0,1.89-1.89V6.39A1.89,1.89,0,0,0,19.621,4.5ZM11.115,17.731,6.39,13.005l1.333-1.333,3.393,3.383,7.173-7.173,1.333,1.342Z" transform="translate(-4.5 -4.5)" fill="#fff"/>
</svg>
 Kennel License</li>
    </ul>
    
    
        </div>
   
    </Col>
    <Col md="4">
        
    <div className="box">
<h4>Popular</h4>
<h1><strong>$</strong>102<span>/12 month</span></h1>
<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500sLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</p>
    
    <ul>
        <li>
            <svg xmlns="http://www.w3.org/2000/svg" width="17.011" height="17.011" viewBox="0 0 17.011 17.011">
  <path id="Icon_material-check-box" data-name="Icon material-check-box" d="M19.621,4.5H6.39A1.89,1.89,0,0,0,4.5,6.39V19.621a1.89,1.89,0,0,0,1.89,1.89H19.621a1.89,1.89,0,0,0,1.89-1.89V6.39A1.89,1.89,0,0,0,19.621,4.5ZM11.115,17.731,6.39,13.005l1.333-1.333,3.393,3.383,7.173-7.173,1.333,1.342Z" transform="translate(-4.5 -4.5)" fill="#fff"/>
</svg>
 Park License</li>
      
    </ul>
    
    
        </div>
   
    </Col>
    <Col md="4"></Col>
</Row>


       
       </Card>
        </Col>
</Row>
     
       
       
        </Container>
      </div>
    </div>
  );
}
